import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Vendedor } from "@/shared/types/vendedor";

export interface VendedorEditRequest {
    nombre: string,
    numDocumento: string,
    email?: string,
    telefono?: string,
    direccion?: string,
}

export async function editVendedor(id: string, request: VendedorEditRequest): Promise<Vendedor> {
    await sleep(1000);
    const response = await api.put("vendedores/" + id, request);
    return response.data;
}

export function useEditVendedorMutation(id: string, mutationConfig: MutationConfig<Vendedor, VendedorEditRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: VendedorEditRequest) => await editVendedor(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["vendedores"] });
        },
    })
}

export interface EditVendedorMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Vendedor, VendedorEditRequest>,
    children?:(mutationResult:MutationResult<Vendedor, VendedorEditRequest>)=>ReactNode
}

export function EditVendedorMutation({
    id,
    children,
    mutationConfig
}:EditVendedorMutationProps){
    const mutationResult = useEditVendedorMutation(id, mutationConfig);
    return children&&children(mutationResult)
}